import { useEffect, useState } from 'react';
import Layout from '../components/Layout.jsx';
import { api, getUser } from '../api.js';
import { ProductoFoto, emojiProducto } from '../components/ProductoCard.jsx';

const fmt = (n) => '$ ' + new Intl.NumberFormat('es-CO').format(n ?? 0);

const CATS = [
  { v: 'bebida_alcoholica', l: 'Alcohol' },
  { v: 'bebida_no_alcoholica', l: 'Bebidas' },
  { v: 'snack', l: 'Snacks' },
  { v: 'tabaqueria', l: 'Tabaco' },
  { v: 'farmacia', l: 'Farmacia' },
  { v: 'otro', l: 'Otros' },
];

export default function Productos() {
  const user = getUser();
  const [productos, setProductos] = useState([]);
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [showNew, setShowNew] = useState(false);
  const [newForm, setNewForm] = useState({ sku: '', nombre: '', categoria: 'otro', precio_venta: 0, costo_unitario: 0, foto_url: '' });

  const cargar = async () => {
    const r = await api.productos();
    setProductos(r.productos);
  };
  useEffect(() => { cargar(); }, []);

  const puedeEditar = user?.rol === 'admin' || user?.rol === 'contador';

  const editar = (p) => {
    setEditing(p.id);
    setEditForm({ precio_venta: p.precio_venta, costo_unitario: p.costo_unitario, foto_url: p.foto_url ?? '', nombre: p.nombre });
  };

  const guardar = async () => {
    await api.actualizarProducto(editing, {
      precio_venta: Number(editForm.precio_venta),
      costo_unitario: Number(editForm.costo_unitario),
      foto_url: editForm.foto_url || null,
      nombre: editForm.nombre,
    });
    setEditing(null);
    await cargar();
  };

  const crear = async (e) => {
    e.preventDefault();
    await api.crearProducto({
      ...newForm,
      precio_venta: Number(newForm.precio_venta),
      costo_unitario: Number(newForm.costo_unitario),
      foto_url: newForm.foto_url || null,
    });
    setNewForm({ sku: '', nombre: '', categoria: 'otro', precio_venta: 0, costo_unitario: 0, foto_url: '' });
    setShowNew(false);
    await cargar();
  };

  const porCategoria = CATS.map((c) => ({ ...c, items: productos.filter((p) => p.categoria === c.v) }));

  return (
    <Layout>
      <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
        <div>
          <p className="eyebrow mb-2">Catálogo</p>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Productos</h1>
          <p className="text-muted mt-3">{productos.length} productos · pega URL de foto para que se vea bonito en el POS</p>
        </div>
        {puedeEditar && (
          <button onClick={() => setShowNew((s) => !s)} className="btn-primary">{showNew ? 'Cancelar' : '+ Nuevo'}</button>
        )}
      </div>

      {showNew && (
        <form onSubmit={crear} className="card mb-6 grid grid-cols-1 md:grid-cols-6 gap-4">
          <div>
            <label className="label">SKU</label>
            <input className="input font-mono" value={newForm.sku} onChange={(e) => setNewForm({ ...newForm, sku: e.target.value })} />
          </div>
          <div className="md:col-span-2">
            <label className="label">Nombre</label>
            <input className="input" value={newForm.nombre} onChange={(e) => setNewForm({ ...newForm, nombre: e.target.value })} required />
          </div>
          <div>
            <label className="label">Categoría</label>
            <select className="input" value={newForm.categoria} onChange={(e) => setNewForm({ ...newForm, categoria: e.target.value })}>
              {CATS.map((c) => <option key={c.v} value={c.v}>{c.l}</option>)}
            </select>
          </div>
          <div>
            <label className="label">Precio venta</label>
            <input className="input" type="number" value={newForm.precio_venta} onChange={(e) => setNewForm({ ...newForm, precio_venta: e.target.value })} />
          </div>
          <div>
            <label className="label">Costo</label>
            <input className="input" type="number" value={newForm.costo_unitario} onChange={(e) => setNewForm({ ...newForm, costo_unitario: e.target.value })} />
          </div>
          <div className="md:col-span-6">
            <label className="label">URL foto (opcional)</label>
            <input className="input font-mono text-xs" value={newForm.foto_url} onChange={(e) => setNewForm({ ...newForm, foto_url: e.target.value })} placeholder="https://..." />
          </div>
          <div className="md:col-span-6">
            <button className="btn-accent">Guardar producto</button>
          </div>
        </form>
      )}

      <div className="space-y-8">
        {porCategoria.filter((c) => c.items.length > 0).map((c) => (
          <div key={c.v}>
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold tracking-tight">{c.l}</h2>
              <span className="pill">{c.items.length} ítems</span>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
              {c.items.map((p) => (
                <div key={p.id} className="rounded-3xl border border-line bg-paper p-3 hover:shadow-md transition">
                  <ProductoFoto producto={p} />
                  <div className="mt-3 px-1">
                    <div className="font-semibold tracking-tight text-sm leading-tight line-clamp-2 min-h-[2.6em]">{p.nombre}</div>
                    <div className="flex items-center justify-between mt-2">
                      <span className="font-mono text-xs text-muted">{p.sku ?? '—'}</span>
                      <span className="font-mono text-sm font-semibold text-ink">{p.precio_venta > 0 ? fmt(p.precio_venta) : <span className="text-muted">$ —</span>}</span>
                    </div>
                  </div>
                  {puedeEditar && (
                    <button onClick={() => editar(p)} className="w-full mt-3 py-2 rounded-2xl bg-bone hover:bg-line transition font-medium text-xs tracking-tight">
                      Editar
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Modal edit */}
      {editing && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4 bg-ink/40 backdrop-blur-sm" onClick={() => setEditing(null)}>
          <div onClick={(e) => e.stopPropagation()} className="card max-w-md w-full">
            <p className="eyebrow mb-2">Editar producto</p>
            <h2 className="text-xl font-semibold tracking-tight mb-5">{editForm.nombre}</h2>
            <div className="space-y-4">
              <div>
                <label className="label">Nombre</label>
                <input className="input" value={editForm.nombre} onChange={(e) => setEditForm({ ...editForm, nombre: e.target.value })} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="label">Precio venta</label>
                  <input className="input" type="number" value={editForm.precio_venta} onChange={(e) => setEditForm({ ...editForm, precio_venta: e.target.value })} />
                </div>
                <div>
                  <label className="label">Costo</label>
                  <input className="input" type="number" value={editForm.costo_unitario} onChange={(e) => setEditForm({ ...editForm, costo_unitario: e.target.value })} />
                </div>
              </div>
              <div>
                <label className="label">URL foto</label>
                <input className="input font-mono text-xs" value={editForm.foto_url} onChange={(e) => setEditForm({ ...editForm, foto_url: e.target.value })} placeholder="https://..." />
                {editForm.foto_url && (
                  <div className="mt-2 h-24 rounded-2xl bg-bone overflow-hidden">
                    <img src={editForm.foto_url} alt="preview" className="w-full h-full object-cover" />
                  </div>
                )}
              </div>
              <div className="flex gap-2 pt-2">
                <button onClick={guardar} className="btn-primary flex-1">Guardar</button>
                <button onClick={() => setEditing(null)} className="btn-secondary">Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
